<script lang="ts">
  import ClassicGame from './ClassicGame.svelte';
  import GameContext from '~/store/GameContext.svelte';
  import ClassicTutorialModal from '~/tutorial/classic/ClassicTutorialModal.svelte';
  import ClassicOnboarding from '~/tutorial/classic/ClassicOnboarding.svelte';
  import Loading from '~/components/Loading.svelte';
  import { ClassicGame as Classic } from '~/store/classic.svelte';
  import Leaderboard from '~/leaderboard/LeaderboardModal.svelte';
  import { dims } from '~/utils/dimensions.svelte';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';
  import SyncModal from './SyncModal.svelte';
  import { hydrated, onboarded } from '~/tutorial/state.svelte';
</script>

<DimensionsContext {dims}>
  {#if !hydrated.current}
    <Loading />
  {:else if !onboarded.current}
    <ClassicOnboarding />
  {:else}
    {#await Classic.load()}
      <Loading />
    {:then game}
      <GameContext {game}>
        <ClassicGame />
        <Leaderboard />
        <SyncModal />
      </GameContext>
    {/await}
    <ClassicTutorialModal />
  {/if}
</DimensionsContext>
